import * as React from 'react';
import {CATEGORIES} from "../../../enums/categories";
import { listenForSongChange } from '../../../actions/hooks';

declare global {
	interface Window {
		audioItem: any;
    currentlyPlaying: string;
	}
}

export type Nomination = {
	Id: number
	Title: string
	Hook: string,
	Artist?: string
}

type Props = {
	nomination: Nomination,
	category: number,
	disabled: boolean,
	setCurrentTarget: (e: any) => void,
	onChange: (e: number) => void
};
export const ListItem = ({nomination, category, disabled, setCurrentTarget, onChange}: Props) => {
	const [checked, setChecked] = React.useState(false);
	const [playing, setPlaying] = React.useState(false);
	let nominationValues = ''
	if (
		CATEGORIES.BG_PESEN === category ||
		CATEGORIES.BG_TEKST === category ||
		CATEGORIES.BG_ALBUM === category ||
		CATEGORIES.BG_VIDEOKLIP === category
	) {
		nominationValues = `${nomination.Artist} - ${nomination.Title}`
	} else {
		nominationValues = ` ${nomination.Artist}`
	}
	let hook = nomination.Hook;
	if (hook.length < 3) {
		do {
			hook = '0' + hook;
		} while (hook.length < 3)
	}

	const renderIcon = () => {
		if (playing) {
			return <>&#9724;</>
		} else {
			return <>&#9654;</>;
		}
	}

	const songChanged = (currentHook: any) => {
		if (playing) {
			if (currentHook.detail !== hook) {
				setPlaying(false);
			}
		}
	}

	React.useEffect(() => {
		listenForSongChange(songChanged);
	},[playing]);
	
	const audio = (
		<div className='audio-icon'>
			<i className={playing ? 'stop' : ''} onClick={(e) => {
				if (window.audioItem) {
					window.audioItem.pause();
					if (window.currentlyPlaying === hook) {
						window.currentlyPlaying = null;
						setPlaying(false);
						return;
					}
				}
							
				window.audioItem = new Audio(`./hooks/${hook}.mp3`);
				window.audioItem.volume = 0.5;
				window.audioItem.play();
				window.currentlyPlaying = hook;

				document.dispatchEvent(new CustomEvent("songChanged", {'detail': hook}));
				setCurrentTarget(e.target)
				setPlaying(true);
			}}>
			{renderIcon()}</i>
		</div>
	);
	
	return (
		<div className={'custom-control custom-checkbox nomination-item'}>
			{audio}
			<div>
				<input
					key={`${category}-${nomination.Id}`}
					type="checkbox"
					name={`${category}-${nomination.Id}`}
					disabled={disabled}
					className="custom-control-input"
					id={`${category}-${nomination.Id}`}
					onChange={(e) => {
						setChecked(!checked);
						onChange(nomination.Id);
					}}/>
				<label htmlFor={`${category}-${nomination.Id}`} className={`custom-control-label`}><span>{nominationValues}</span></label>
			</div>
		</div>
	);
};
